import {
	AddProduct,
	AdminDashboard,
	AdminOrders,
	EditProduct,
	Products,
	SingleProduct,
	ThemeSelector,
	WebsiteConfiguration,
} from '../pages';
import constant from '../utils/constant';

const protectedRoutes = [
	{
		path: constant.Routes.Admin.Dashboard,
		element: <AdminDashboard />,
	},
	{
		path: constant.Routes.Admin.Products,
		element: <Products />,
	},
	{
		path: constant.Routes.Admin.AddProduct,
		element: <AddProduct />,
	},
	{
		path: constant.Routes.Admin.EditProduct,
		element: <EditProduct />,
	},
	{
		path: constant.Routes.Admin.SingleProduct,
		element: <SingleProduct />,
	},
	{
		path: constant.Routes.Admin.Products,
		element: <Products />,
	},
	{
		path: constant.Routes.Admin.Orders,
		element: <AdminOrders />,
	},
	{
		path: constant.Routes.Admin.Orders,
		element: <AdminOrders />,
	},
	{
		path: constant.Routes.Admin.WebsiteConfiguration,
		element: <WebsiteConfiguration />,
	},
	{
		path: constant.Routes.Admin.ThemeSelector,
		element: <ThemeSelector />,
	},
];

export default protectedRoutes;
